import React from 'react';
import { Card, CardContent, Divider } from '@mui/material';
import PageWrapperLayout from '../../components/PageWrapperLayout/PageWrapperLayout';
import MDBox from '../../ui-kit/components/MDBox';
import background from '../../../bg.jpeg'
import { Col, Row } from 'react-bootstrap';
import MDTypography from '../../ui-kit/components/MDTypography';

const PasswordResetConfirmation = (): JSX.Element => {
    
    
  return (
    <PageWrapperLayout>
        <MDBox sx={{'height': '100%', minHeight: '100vh', display: 'flex', flexDirection: 'column', backgroundImage: `url(${background})`,backgroundSize: "cover",
         backgroundRepeat: "no-repeat",}}>

            <MDBox sx={{ margin: '0 auto', width: '80%', height: '80%', minHeight: '80%', maxHeight: '80%', align:'center'}}>
                <Row>
                    <Col className='col -lg-4 col-md-8 col-12 mx-auto'>
                        <Card sx={{mt:30}} >
                            <CardContent>
                                <MDTypography variant="h3">
                                    Reset Password Confirmation
                                </MDTypography>
                            </CardContent>
                            <Divider />
                            <MDTypography>
                                Check your email for a link to set your password!
                            </MDTypography>
                            
                        </Card>
                    </Col>
                </Row>
            </MDBox>
        </MDBox>

    </PageWrapperLayout>
  );
};

export default PasswordResetConfirmation;
